import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";

import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import SVG from "react-inlinesvg";

import paginationFactory from "react-bootstrap-table2-paginator";
import { formatDate, sizePerPageList } from "../../utility";

// import Pagination from 'react-bootstrap/Pagination'
import { useHistory } from "react-router";

export const NewRegistartionTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const [tableData, setTableData] = useState(data);
  const history = useHistory();
  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);

    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,

      };
    });

    setTableData(initData);
  }, [data, sizePerPage, page]);

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };


  const columns = [
    {
      dataField: "no",
      text: "no",
      sort: true,
    },
    {
      dataField: "customer_name",
      text: "Customer Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "invoice_ref_no",
      text: "invoice ref no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "ret_number",
      text: "Ireturn No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   dataField: "material_name",
    //   text: "Material Desc",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      dataField: "reason",
      text: "Reason",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "plant_name",
      text: "Plant",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "username",
      text: "created user",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "created_date",
      text: "created date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
    },

    {
      dataField: "detail",
      text: "Detail",
      formatter: (cell, row) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={(e) =>
                history.push(`/report-return/report-header/${row.ret_number}`, {
                  params: row.ret_number,
                })
              }
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <>
     <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        noDataIndication="New Registration is Empty"
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
    </>
  );
};
